// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-time{display:flex}.event-time .event-all-fields{display:flex;flex-direction:column;flex:1}.event-time .event-all-fields .event-type,.event-time .event-all-fields .event-fields{display:flex}.event-time .event-all-fields .event-fields{display:flex;flex-direction:column}.event-time .event-tip{flex:1}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
